import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  breakpointSizes,
  fluidFontSize,
  fontWeights,
  maxBreakpointQuery,
  sectionMargins,
} from '../utilities';
import { Container, HeadingWithBackgroundText } from './ui';

const TableWrapper = styled.section`
  ${sectionMargins()};
`;

const TableHtml = styled.div`
  ${maxBreakpointQuery.mlarge`
    overflow-x: scroll;
    thead td {
      min-width: 160px;
    }
  `}

  table,
  thead,
  tbody,
  th,
  td,
  tr {
    border: 0;
  }

  table {
    text-align: center;
    ${fluidFontSize(
      '14px',
      '16px',
      breakpointSizes.mlarge,
      breakpointSizes.large
    )}
  }

  tbody tr:nth-child(odd) {
    background: ${brandColours.quinary};
  }

  thead {
    color: ${brandColours.primary};
    font-weight: ${fontWeights.bold};
  }

  td {
    padding: 16px 12px;

    p {
      margin-top: 10px;
      line-height: 1.5;

      &:first-child {
        margin-top: 0;
      }
    }
  }
`;

const Table = ({ id, heading, headingBackgroundText, table }) => {
  return (
    <TableWrapper>
      <Container>
        <HeadingWithBackgroundText
          heading={heading}
          headingBackgroundText={headingBackgroundText}
        />
        <TableHtml
          id={`table-${id}`}
          dangerouslySetInnerHTML={{ __html: table }}
        />
      </Container>
    </TableWrapper>
  );
};

export default Table;
